
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ComplianceStatus',
  props: {
    compliancePassed: {
      type: Boolean,
      required: true
    },
    textSize: {
      type: String,
      default: 'text-13px',
      validator: (value: string) => value.startsWith('text-')
    }
  }
})
